<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.6665 3.33203V16.6654M1.6665 6.66536H16.6665C17.1085 6.66536 17.5325 6.84096 17.845 7.15352C18.1576 7.46608 18.3332 7.89 18.3332 8.33203V16.6654M1.6665 14.1654H18.3332M4.99984 6.66536V14.1654" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
